import React from "react"
import Layout from "../Layout"

const SafeAreaView = ({ children, ...props }) => <Layout {...props}>{children}</Layout>

export default SafeAreaView
